<template>
    <div>
        <zm-row>
            <zm-button size="small" @click="fetchData()" type="primary" class="btn-in-line" plain>refresh</zm-button>
        </zm-row>
        <div class="table-container" v-loading="loading">
        <zm-form label-position="left" class="demo-table-expand">
            <zm-form-item label="Global Status">
                <img class="point" v-if="clusterStatus === 'RED'" src="../../assets/red-point.png">
                <img class="point" v-if="clusterStatus === 'GREEN'" src="../../assets/green-point.png">
                <img class="point" v-if="clusterStatus === 'YELLOW'" src="../../assets/yellow-point.png">
            </zm-form-item>
        </zm-form>
        <zm-table :data="nodeInfos" border>
            <zm-table-column prop="id" label="id"></zm-table-column>
            <zm-table-column prop="host" label="host"></zm-table-column>
            <zm-table-column prop="nodeStatus" label="nodeStatus"></zm-table-column>
            <zm-table-column prop="nodeRole" label="nodeRole"></zm-table-column>
        </zm-table>
        </div>
        <div v-loading="localLoading">
        <zm-form label-position="left" class="demo-table-expand" style="margin-top: 30px">
            <zm-form-item label="Local Status">
                <img class="point" v-if="localClusterStatus === 'RED'" src="../../assets/red-point.png">
                <img class="point" v-if="localClusterStatus === 'GREEN'" src="../../assets/green-point.png">
                <img class="point" v-if="localClusterStatus === 'YELLOW'" src="../../assets/yellow-point.png">
            </zm-form-item>
        </zm-form>
        <zm-table :data="localNodeInfos" border>
            <zm-table-column prop="id" label="id"></zm-table-column>
            <zm-table-column prop="host" label="host"></zm-table-column>
            <zm-table-column prop="nodeStatus" label="nodeStatus"></zm-table-column>
            <zm-table-column prop="nodeRole" label="nodeRole"></zm-table-column>
        </zm-table>
        </div>
    </div>
</template>
<script>
import { getZK, getGlobalZK } from '../../api/index'
export default {
    name: 'zk',
    data () {
        return {
            nodeInfos: [],
            clusterStatus: '',
            localNodeInfos: [],
            localClusterStatus: '',
            role: localStorage.role,
            loading: false,
            localLoading: false,
            pageable: {
                pageNumber: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created () {
        localStorage.params = ''
        localStorage.path = this.$route.path
        this.fetchData()
    },
    methods: {
        fetchData () {
            this.localLoading = true
            getZK().then(response => {
                this.localNodeInfos = response.nodeInfo
                this.localClusterStatus = response.clusterStatus
                this.localLoading = false
            }).catch(() => {
                this.localLoading = false
            })
            this.loading = true
            getGlobalZK().then(response => {
                this.nodeInfos = response.nodeInfo
                this.clusterStatus = response.clusterStatus
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
<style>
.btn-in-line{
    margin: 10px;
}
.search-input{
    float: right;
    margin: 10px;
    width: 200px;
}
.point {
    height: 15px;
    margin-top: 8px;
}
</style>
